@import './pk-segmented-control-item.variables';

:host {
  @apply flex min-w-0 flex-1;
}

.pk-segmented-control-item {
  all: unset;
  @apply z-[1] box-border w-full cursor-pointer select-none justify-items-center truncate rounded-l p-[--segmented-control-item--padding];
  @apply text-center text-[length:--segmented-control-item--font-size] text-[color:--segmented-control-item--text-color];
  @apply transition-colors duration-300;
  // Focus
  @apply focus-visible:focus-outline;
  // Hover
  @apply hover:text-interaction [&:not(.active)]:hover:bg-[--segmented-control-item--bgColor-hover];
}
